import React, {useEffect, useRef, useState} from 'react';
import { Dropdown, Button } from 'react-bootstrap';
import SvgIcon from "../../../components/svg-icon";

const NetworkDropdown = ({ networks, theNetwork, handleSelectNetwork }) => {
    const [show, setShow] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = (isOpen) => {
        setShow(isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShow(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);
    return (
        <Dropdown
            ref={dropdownRef}
            className="modal__wallet-dropdown modal__wallet-dropdown--double"
            show={show}
            onToggle={toggleDropdown}

        >
            <Dropdown.Toggle
                as={Button}
                disabled={networks?.length <= 1}
                className="modal__wallet-dropdown-btn"
                id="modalWallet01"
                onClick={() => setShow(!show)}
                aria-expanded={show}
            >
                {theNetwork}
                <SvgIcon id={'right-down'}/>
            </Dropdown.Toggle>

            <Dropdown.Menu className="modal__wallet-menu" aria-labelledby="modalWallet01">
                <ul className="modal__wallet-currencies">
                    {networks?.map((nett) => (
                        <li
                            key={nett?.name}
                            onClick={() => {
                                handleSelectNetwork(nett);
                                setShow(false); // Close dropdown after selecting
                            }}
                        >
                            <span className="gapp2">{nett?.key}</span>
                        </li>
                    ))}
                </ul>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default NetworkDropdown;
